import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AdditionalDetails from '../AdditionalDetails';
import { formatAddressSingleLine } from '../../lib/addresses';
import { timeWindowFormatter, localeDateTime } from '../../lib/dates';

export const mapStateToProps = ({
  page: { countryCode } = {},
  returnOptions: { selectedOptionMethodKey },
  carrierPickup: { date, address, timeWindow } = {},
  language: {
    [`returns.step_3.carrier_pickup.${selectedOptionMethodKey}.pickup_details.title`]: title,
    [`returns.step_3.carrier_pickup.${selectedOptionMethodKey}.pickup_details.date_label`]:
      dateLabel,
    [`returns.step_3.carrier_pickup.${selectedOptionMethodKey}.pickup_details.address_label`]:
      addressLabel,
  },
}) => ({
  address,
  date,
  title,
  dateLabel,
  addressLabel,
  timeWindow,
  countryCode,
});

const PickupDetails = ({
  address,
  date,
  title,
  dateLabel,
  addressLabel,
  timeWindow,
  countryCode,
}) => {
  const dateDisplay = localeDateTime({ date, countryCode });

  return (
    <AdditionalDetails
      wrapperStyle="padding: 0"
      headerStyle="font-weight: 700"
      title={title}
      items={[
        ...(date
          ? [
              {
                key: dateLabel,
                label: dateLabel,
                value: `${dateDisplay} ${timeWindow ? timeWindowFormatter(timeWindow, countryCode) : ''}`,
              },
            ]
          : []),
        {
          key: addressLabel,
          label: addressLabel,
          value: formatAddressSingleLine({
            address: {
              name: `${address.first_name} ${address.last_name}`,
              company: address.company_name,
              address1: address.address_line1,
              address2: address.address_line2,
              city: address.city,
              region: address.province,
              country: address.country,
              postalCode: address.postal_code,
            },
            countryCode: address.country,
          }),
        },
      ]}
    />
  );
};

PickupDetails.defaultProps = {
  title: '',
  dateLabel: '',
  addressLabel: '',
  timeWindow: '',
};

PickupDetails.propTypes = {
  address: PropTypes.object.isRequired,
  date: PropTypes.string.isRequired,
  title: PropTypes.string,
  dateLabel: PropTypes.string,
  addressLabel: PropTypes.string,
  timeWindow: PropTypes.string,
  countryCode: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(PickupDetails);
